import { addError } from '@shared/utils/logger';

type AutoPopulationContext = 'CreateWedding' | 'GeneralSettings' | 'EventVenue';

type AutoPopulationTask = Readonly<{
  operation: string;
  enabled: boolean;
  run: () => Promise<unknown>;
}>;

/**
 * Runs multiple auto-population tasks in parallel with error logging.
 * Tasks that are not enabled are skipped. Errors are logged but do not
 * prevent other tasks from completing (uses Promise.allSettled).
 */
export const runAutoPopulationTasks = async (context: AutoPopulationContext, eventId: string, tasks: ReadonlyArray<AutoPopulationTask>): Promise<void> => {
  const promises = tasks
    .filter(task => task.enabled)
    .map(async task => {
      try {
        return await task.run();
      } catch (error) {
        addError(error, {
          context: `${context}/autoPopulation`,
          eventId,
          operation: task.operation,
        });
        throw error;
      }
    });
  await Promise.allSettled(promises);
};
